import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgKosar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#kosar_svg__a)'>
      <path
        fill='#940509'
        d='M14.048.676c.785-.27 1.563-.669 2.405-.675.194-.035.192.223.242.354.242.949.585 1.869.785 2.826-.064.193-.302.14-.448.181a14 14 0 0 0-5.259 1.723c-1.812 1.072-3.351 2.748-4.09 4.812-.571 1.365-.753 2.876-.72 4.358-.045 1.454.336 2.877.83 4.223A15.5 15.5 0 0 1 6.2 13.315c-.045-1.243-.112-2.512.207-3.725.26-1.45.897-2.8 1.698-4.004C9.632 3.418 11.686 1.72 14.05.673zm-.335 6.003c.434-.058.854.107 1.277.181 2.841.578 5.511 2.313 7.076 4.9 1.57 2.656 2.158 5.888 1.859 8.98-.09 1.06-.386 2.097-.692 3.112-.042.22-.296.13-.44.118-.98-.236-1.942-.551-2.915-.825.875-1.892 1.51-3.95 1.57-6.07.031-1.24-.067-2.508-.494-3.676-.77-2.409-2.567-4.315-4.61-5.598a26 26 0 0 0-1.495-.7c-.37-.164-.79-.19-1.133-.423zm-1.25 3c1.166-.254 2.467-.084 3.436.69 1.176.857 1.813 2.404 1.726 3.886-.112.768-.285 1.561-.741 2.192-.806 1.169-2.167 1.973-3.564 1.86-2.033.03-3.891-1.804-4.026-3.927a4.6 4.6 0 0 1 .239-2.002 4.4 4.4 0 0 1 1.066-1.679c.539-.478 1.168-.869 1.864-1.023zm.224.273c-1.098.253-2.121.985-2.631 2.053-.337.692-.548 1.471-.478 2.251.123.959.485 1.91 1.172 2.576 1.051 1.111 2.773 1.495 4.149.85.955-.363 1.704-1.198 2.099-2.17.842-1.878-.045-4.344-1.837-5.201a3.46 3.46 0 0 0-2.467-.36zM.646 17.31c.56-.554 1.02-1.201 1.57-1.757.48.556.89 1.177 1.397 1.704 1.62 1.866 3.729 3.377 6.122 3.852 2.65.53 5.4-.353 7.573-1.957.863-.64 1.54-1.498 2.252-2.306-.672 1.202-1.58 2.23-2.536 3.188-1.638 1.605-3.723 2.616-5.95 2.884-1.057.01-2.13.102-3.172-.147a12.3 12.3 0 0 1-2.605-.776 12.2 12.2 0 0 1-4.5-2.945A5.5 5.5 0 0 1 0 18.148c.135-.333.424-.561.645-.824'
      />
      <path
        fill='#FECB05'
        d='M12.686 9.955a3.46 3.46 0 0 1 2.467.36c1.794.857 2.68 3.323 1.837 5.201-.395.972-1.144 1.807-2.1 2.17-1.37.645-3.092.26-4.148-.85-.687-.667-1.049-1.618-1.172-2.576-.07-.78.145-1.56.477-2.251.51-1.068 1.534-1.8 2.632-2.054'
      />
    </g>
    <defs>
      <clipPath id='kosar_svg__a'>
        <path fill='#fff' d='M0-.002h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgKosar)
export default ForwardRef
